<template>
  <!-- breadcrumb -->
  <div class="lg:pt-3 lg:mt-n5 relative">
    <div class="hidden lg:block absolute w-100 h-100 top-0 left-0 bg-primary-100" />
    <div class="container lg:px-6">
      <BreadCrumb
        :breadcrumb-list="breadcrumbList"
        additional-class-name="lg:justify-center xl:justify-start"
      />
    </div>
  </div>
  <!-- Navigation top space -->
  <div class="hidden lg:block xl:hidden pt-6 pb-8 bg-primary-100" />
  <!-- navigation content -->
  <section
    id="js-anchor-links"
    class="py-1 hidden lg:block sticky-top bg-primary-100"
  >
    <div class="container">
      <div class="nav xl:flex-nowrap">
        <div class="col-12 xl:col mb-4 mt-n9 xl:mt-0 xl:mb-0 text-center xl:text-left">
          <h1 class="h2 mb-2">
            {{ title }}
          </h1>
          <p
            class="mb-0 small"
            v-html="description"
          />
        </div>
        <MixesNavigationItem
          v-for="(step, index) in allSteps"
          :key="index"
          :current-index="index"
          :step="step"
          :is-last="allSteps.length - 1 === index"
        />
      </div>
    </div>
  </section>
  <!-- navigation wave -->
  <Wave
    path="waveFour"
    color="text-primary-200"
    :x-center="false"
    class="hidden lg:block relative pt-7 bg-primary-100"
  />
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import BreadCrumb from '@/components/general/BaseBreadcrumb.vue'
import Wave from '@/components/general/BaseWave.vue'
import MixesNavigationItem from '@/components/mixes/MixesNavigationItem.vue'
import useHead from '@/mixins/headManager'

const props = defineProps({
  allSteps: {
    type: Array,
    default: () => [],
  },

  title: {
    type: String,
    required: true,
  },

  description: {
    type: String,
    required: true,
  },
})
const { t } = useI18n()
const route = useRoute()

const breadcrumbList = ref([
  {
    name: t('mixing'),
    link: route.fullPath,
  },
])

useHead({
  title: props.title,
  meta: [
    {
      property: `og:title`,
      content: props.title,
    },
    {
      property: `og:description`,
      content: props.description,
    },
  ],
})
</script>

<i18n>
  {
    "cs": {
    "mixing": "Mixování"
},
    "sk": {
    "mixing": "Mixovanie"
},
    "pl": {
    "mixing": "Mixowanie"
},
    "hu": {
    "mixing": "Mixelés"
},
    "de": {
    "mixing": "Mixen"
},
    "at": {
    "mixing": "Mixen"
},
    "ro": {
    "mixing": "Amestec"
},
    "fr": {
    "mixing": "Mixage"
}
  }
</i18n>
